(() => {
  const focusableSelector =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  const trapFocus = (container, event) => {
    const focusable = [...container.querySelectorAll(focusableSelector)].filter(
      (el) => !el.hasAttribute('disabled') && el.offsetParent !== null
    );
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  window.theme = window.theme || {};
  window.theme.trapFocus = trapFocus;

  window.theme.formatMoney = (cents, format) => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = (Number(cents) / 100).toFixed(2);
    const formatString = format || window.theme.moneyFormat || '${{amount}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = formatString.match(placeholderRegex);
    if (!match) return formatString.replace(placeholderRegex, value);

    let formatted = value;
    switch (match[1]) {
      case 'amount_no_decimals':
        formatted = (Number(cents) / 100).toFixed(0);
        break;
      case 'amount_with_comma_separator':
        formatted = value.replace('.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = (Number(cents) / 100).toFixed(0).replace('.', ',');
        break;
      default:
        formatted = value;
    }
    return formatString.replace(placeholderRegex, formatted);
  };

  window.theme.showToast = (message) => {
    const toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.hidden = false;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => {
        toast.hidden = true;
      }, 220);
    }, 2200);
  };

  /* Mobile nav */
  const mobileNav = document.getElementById('MobileNav');
  const mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  const mobileClose = document.querySelector('[data-mobile-nav-close]');

  const setMobileNav = (open) => {
    if (!mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', String(open));
    if (open) {
      const panel = mobileNav.querySelector('.mobile-nav__panel');
      const focusTarget = panel?.querySelector(focusableSelector);
      focusTarget?.focus();
    } else {
      mobileToggle?.focus();
    }
  };

  mobileToggle?.addEventListener('click', () => setMobileNav(true));
  mobileClose?.addEventListener('click', () => setMobileNav(false));
  mobileNav?.querySelector('[data-mobile-nav-overlay]')?.addEventListener('click', () => setMobileNav(false));
  mobileNav?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMobileNav(false);
    if (event.key === 'Tab') trapFocus(mobileNav.querySelector('.mobile-nav__panel'), event);
  });

  /* Search modal */
  const searchModal = document.getElementById('SearchModal');
  const searchOpeners = document.querySelectorAll('[data-search-open]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.getElementById('SearchModalInput');
  const searchResults = document.getElementById('SearchModalResults');
  let searchTimer;

  const setSearch = (open) => {
    if (!searchModal) return;
    searchModal.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      searchInput?.focus();
    }
  };

  searchOpeners.forEach((btn) => btn.addEventListener('click', () => setSearch(true)));
  searchClose?.addEventListener('click', () => setSearch(false));
  searchModal?.addEventListener('click', (event) => {
    if (event.target === searchModal) setSearch(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && searchModal?.classList.contains('is-open')) setSearch(false);
  });

  const renderSearchResults = (products) => {
    if (!searchResults) return;
    if (!products.length) {
      searchResults.innerHTML = '<p class="cart-note">No products found.</p>';
      return;
    }
    searchResults.innerHTML = products
      .map((product) => {
        const image = product.image
          ? `<img src="${product.image}" alt="${product.title.replace(/"/g, '&quot;')}" width="70" height="70" loading="lazy">`
          : '';
        return `
          <a class="search-result" href="${product.url}">
            <div class="search-result__image">${image}</div>
            <div>
              <div class="product-card__title">${product.title}</div>
              <div class="product-card__price">${product.price}</div>
            </div>
          </a>`;
      })
      .join('');
  };

  searchInput?.addEventListener('input', (event) => {
    const q = event.target.value.trim();
    clearTimeout(searchTimer);
    if (!window.theme.routes?.predictive_search_url || q.length < 2) {
      if (searchResults) searchResults.innerHTML = '';
      return;
    }
    searchTimer = setTimeout(async () => {
      try {
        const url = `${window.theme.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
        const response = await fetch(url);
        if (!response.ok) throw new Error('Search failed');
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const resultsMarkup = doc.querySelector('#shopify-section-predictive-search')?.innerHTML;
        if (resultsMarkup && searchResults) {
          searchResults.innerHTML = resultsMarkup;
        }
      } catch (error) {
        if (searchResults) searchResults.innerHTML = '<p class="cart-note">Search unavailable.</p>';
      }
    }, 250);
  });

  /* Quantity buttons */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-button]');
    if (!button) return;
    const wrapper = button.closest('.quantity');
    const input = wrapper?.querySelector('[data-quantity-input]');
    if (!input) return;
    const current = Number(input.value) || 1;
    const min = Number(input.min) || 1;
    const next = button.dataset.quantityButton === 'plus' ? current + 1 : Math.max(min, current - 1);
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Accordion icons already native via details/summary */

  /* Reveal animations for sections with data-animate */
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const animated = document.querySelectorAll('[data-animate]');
  if (!prefersReduced && 'IntersectionObserver' in window && animated.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    animated.forEach((el) => {
      el.classList.add('will-reveal');
      observer.observe(el);
    });
  } else {
    animated.forEach((el) => el.classList.add('is-revealed'));
  }

  /* Reviews Carousel (2 by 2 slider) */
  const initReviewsCarousels = () => {
    const carousels = document.querySelectorAll('[data-reviews-carousel]');
    carousels.forEach((carousel) => {
      if (carousel._carouselInitialized) return;
      carousel._carouselInitialized = true;

      const track = carousel.querySelector('[data-reviews-track]');
      const slides = carousel.querySelectorAll('.reviews-carousel__slide');
      const prevBtn = carousel.querySelector('[data-reviews-prev]');
      const nextBtn = carousel.querySelector('[data-reviews-next]');
      const dotsContainer = carousel.querySelector('[data-reviews-dots]');

      if (!track || !slides.length) return;

      const totalSlides = slides.length;
      let currentPage = 0;
      let autoplayTimer = null;
      const autoplayEnabled = carousel.dataset.autoplay !== 'false';
      const intervalMs = (Number(carousel.dataset.interval) || 5) * 1000;

      const getPerPage = () => (window.innerWidth >= 750 ? 2 : 1);
      const getTotalPages = () => Math.ceil(totalSlides / getPerPage());

      const renderDots = () => {
        if (!dotsContainer) return;
        const totalPages = getTotalPages();
        dotsContainer.innerHTML = '';
        for (let i = 0; i < totalPages; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `reviews-carousel__dot${i === currentPage ? ' is-active' : ''}`;
          dot.setAttribute('aria-label', `Go to reviews slide ${i + 1}`);
          dot.addEventListener('click', () => {
            goToPage(i);
            resetAutoplay();
          });
          dotsContainer.appendChild(dot);
        }
      };

      const updatePosition = () => {
        const perPage = getPerPage();
        const totalPages = getTotalPages();
        if (currentPage >= totalPages) currentPage = Math.max(0, totalPages - 1);
        if (currentPage < 0) currentPage = 0;

        const firstSlide = slides[0];
        if (!firstSlide) return;
        const slideWidth = firstSlide.getBoundingClientRect().width;
        const computedStyle = window.getComputedStyle(track);
        const gap = parseFloat(computedStyle.gap || computedStyle.columnGap) || 24;

        // Slide 2 by 2:
        let startIndex = currentPage * perPage;
        if (startIndex + perPage > totalSlides) {
          startIndex = Math.max(0, totalSlides - perPage);
        }

        const offset = startIndex * (slideWidth + gap);
        track.style.transform = `translateX(-${offset}px)`;

        if (dotsContainer) {
          const dots = dotsContainer.querySelectorAll('.reviews-carousel__dot');
          dots.forEach((dot, idx) => {
            dot.classList.toggle('is-active', idx === currentPage);
          });
        }
      };

      const goToPage = (pageIndex) => {
        const totalPages = getTotalPages();
        if (pageIndex >= totalPages) {
          currentPage = 0;
        } else if (pageIndex < 0) {
          currentPage = totalPages - 1;
        } else {
          currentPage = pageIndex;
        }
        updatePosition();
      };

      prevBtn?.addEventListener('click', () => {
        goToPage(currentPage - 1);
        resetAutoplay();
      });

      nextBtn?.addEventListener('click', () => {
        goToPage(currentPage + 1);
        resetAutoplay();
      });

      // Keyboard support
      carousel.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          goToPage(currentPage - 1);
          resetAutoplay();
        } else if (e.key === 'ArrowRight') {
          goToPage(currentPage + 1);
          resetAutoplay();
        }
      });

      // Autoplay
      const startAutoplay = () => {
        if (!autoplayEnabled || totalSlides <= 2) return;
        stopAutoplay();
        autoplayTimer = setInterval(() => {
          goToPage(currentPage + 1);
        }, intervalMs);
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      const resetAutoplay = () => {
        stopAutoplay();
        startAutoplay();
      };

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('touchstart', stopAutoplay, { passive: true });
      carousel.addEventListener('touchend', startAutoplay, { passive: true });

      // Touch swipe support
      let touchStartX = 0;
      let touchEndX = 0;
      track.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      track.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            goToPage(currentPage + 1);
          } else {
            goToPage(currentPage - 1);
          }
          resetAutoplay();
        }
      }, { passive: true });

      // Handle window resize
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          renderDots();
          updatePosition();
        }, 150);
      });

      renderDots();
      updatePosition();
      startAutoplay();
    });
  };

  initReviewsCarousels();
  document.addEventListener('shopify:section:load', initReviewsCarousels);

  /* Coming soon card interaction */
  document.addEventListener('click', (event) => {
    const card = event.target.closest('[data-coming-soon="true"]');
    if (!card) return;
    const newsletter =
      document.getElementById('newsletter') ||
      document.getElementById('shopify-section-newsletter') ||
      document.querySelector('.section-newsletter') ||
      document.querySelector('#Newsletter');
    if (newsletter) {
      event.preventDefault();
      newsletter.scrollIntoView({ behavior: 'smooth' });
      const emailInput = newsletter.querySelector('input[type="email"]');
      if (emailInput) setTimeout(() => emailInput.focus(), 650);
      if (window.theme.showToast) {
        window.theme.showToast('Pet charms: Coming soon! Currently in development.');
      }
    }
  });
})();
